// components/DonationButton.js
import React, { useState } from "react";
import DonationModal from "./DonationModal";
import { useTranslation } from "react-i18next";
import { FaHeart } from "react-icons/fa";

export default function DonationButton({ className = "" }) {
  const [showModal, setShowModal] = useState(false);
  const { t } = useTranslation();
  return (
    <>
      <button className={className} onClick={() => setShowModal(true)}>
        <FaHeart />
        <span className="ms-2">{t("general.donate")}</span>
      </button>
      {showModal && <DonationModal onClose={() => setShowModal(false)} />}
    </>
  );
}
